import { ChevronRight } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLoaderData } from '@tanstack/react-router';
import HeroCarousel from './hero-carousel.tsx';
import Section from '@/components/layout/section.tsx';

export default function Hero() {
	const { t } = useTranslation();
	const data = useLoaderData({ from: '__root__' });

	const serviceTitle = data?.serviceAvailabilityBtnTitle;
	const serviceDescription = data?.serviceAvailabilityBtnDescription;

	const baysTitle = data?.baysBtnTitle;
	const baysDescription = data?.baysBtnDescription;

	const photos = data?.playerPhotos || [];

	return (
		<Section className="min-h-[calc(100svh_-_110px_-_72px)] max-2xl:min-h-[calc(100svh_-_94px_-_72px)] max-xl:min-h-[unset] grid grid-cols-12 gap-4">
			<div className="col-span-6 order-1 flex flex-col gap-8 max-lg:col-span-12 max-lg:order-2 max-lg:gap-6 my-auto">
				<div className="flex flex-col gap-6">
					<h1 className="text-7xl max-2xl:text-6xl max-xl:text-5xl max-md:text-4xl font-bold pr-16 max-xl:pr-18 max-lg:pr-0">
						<Trans i18nKey="hero.title">
							Discover a <span className="text-[var(--primary)]">New Standard</span> in Car Service!
						</Trans>
					</h1>

					<p className="text-2xl max-xl:text-xl max-md:text-lg leading-10 max-xl:leading-8 text-neutral-600 pr-4 max-lg:pr-0">
						{t('hero.description')}
					</p>
				</div>

				<Link to="/order-service" className="flex items-center w-fit main-button">
					<span className="w-[320px] h-[80px] max-xl:w-[280px] max-xl:h-[70px] inline-flex items-center text-white gap-4 text-2xl justify-start max-xl:text-xl px-4 rounded-2xl gradient goldman font-medium">
						{t('global.order_button_label')}
					</span>

					<span className="chevron w-[60px] h-[80px] max-xl:h-[70px] max-xl:w-[52px] inline-flex items-center justify-center text-white gap-4 text-lg rounded-2xl gradient goldman font-medium">
						<ChevronRight className="shrink-0 !size-8 max-xl:!size-6" />
					</span>
				</Link>

				<div className="flex items-center gap-4 max-md:flex-wrap">
					<Link
						to="/contacts"
						className="flex flex-col p-4 max-lg:p-3 max-xl:flex-auto cursor-pointer text-[var(--primary)] goldman border-2 border-[var(--primary)] transition-all hover:border-[var(--primary)]/50 active:scale-97 rounded-xl max-lg:w-full"
					>
						<span className="text-5xl max-xl:text-3xl max-md:text-2xl font-bold">
							{serviceTitle}
						</span>
						<span className="text-xl max-xl:text-lg max-md:text-md font-medium">
							{serviceDescription}
						</span>
					</Link>

					<Link
						to="/services"
						className="flex flex-col p-4 max-lg:p-3 max-xl:flex-auto cursor-pointer goldman border-2 border-neutral-600 hover:border-neutral-400 transition-all active:scale-97 rounded-xl max-lg:w-full"
					>
						<span className="text-5xl max-xl:text-3xl max-md:text-2xl font-bold">{baysTitle}</span>
						<span className="text-xl max-xl:text-lg max-md:text-md font-medium">
							{baysDescription}
						</span>
					</Link>
				</div>
			</div>

			<div className="col-span-6 order-2 flex flex-col items-center justify-end m-auto aspect-[16/9] relative max-lg:col-span-12 max-lg:order-1 max-lg:justify-center shrink-0 w-full">
				<HeroCarousel photos={photos} />
			</div>
		</Section>
	);
}
